/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://4s9prfnuki.execute-api.ap-northeast-1.amazonaws.com/daiwaelecs",
            "region": "ap-northeast-1"
        },
        {
            "name": "restapi",
            "endpoint": "https://bkdsnrqpv2.execute-api.ap-northeast-1.amazonaws.com/daiwaelecs",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xpd6hdp3rnaqthbqdmtsptuefq.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-northeast-1:b219a8d3-895e-465f-91ca-2207781b3fc9",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_xCoER1243",
    "aws_user_pools_web_client_id": "2dso5o12pc7ik0c9rkbnvb5o73",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "erpvawsc5cbbc6d3b9a4071a52ea20a63dde10c62118-daiwaelecs",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
